export const currencySignsObj = {
    'usd': '$',
    'eur': '€',
    'euro': '€',
    'shekel': '₪',
    'ILS': '₪',
};

export const currencySignsObjLowerCase = {
    'usd': 'usd',
    'eur': 'eur',
    'euro': 'euro',
    'shekel': 'shekel',
    'ils': 'ils',
};